// Load the environment variable from the .env file
const BaseUrl = process.env.REACT_APP_BASE_URL || "https://localhost:5001/api/";

const Apis = {
  signup: "auth/sign-up",
  signin: "auth/sign-in",
  forgotpass: "auth/forgotpwd",
  changePasswordapi: "auth/reset/",
  payoutlist: "servicePayout/order/",
  payout: "servicePayout/",
  newPayout: "servicePayout/",
  payoutFiles: "serviceFiles/",
  //facility
  facilitylist: "facility/",
  newFacility: "facility",
  suggestionList: "serviceProSgstn/",
  deleteSuggestion: "serviceProSgstn/",
  //refs and city
  refdatatypes: "refs",
  cityListiso: "isoCity/facilityIsoCity",
  cityList: "isoCity",
  svcTyp: "svcTyp",
  //profile
  getProfile: "userPro/?user_email=",
  updateProfile: "userPro/",
  //services
  servicelist: "service/svcf/",
  serviceUrl: "service",
  //bankDetails
  bankdetails: "bank",
  banklist: "bank/userPro/",
  //payment
  paymentgateway: "pay/ps",
  paymentTerms: "pay/stripe-terms",
  //chat
  senderList: "msg/",
  //ordelist
  orderlist: "serviceOrd/userPro/",
  orderlistrange: "serviceOrd/",
  deleteOrderList: "serviceOrd/",
  updateorder: "serviceOrd/",
  resendorder: "msg/resendOrderWUP/",
  financialslist: "serviceFees/userPro/",
  //patient
  patientlist: "svcUserPro/pro/",
  newPatientList: "svcUserPro/",
  updatePatient: "svcUserPro/",
  //fees
  feeslist: "serviceFees/",
  newFees: "serviceFees",
  // add doctor
  newDoctor: "serviceProSgstn/",
  //users
  userlist: "users/",
  alluserlist: "users/all",
  userList: "userPro/",
  cartItem: "pay/sc",
};

export { BaseUrl, Apis };
